import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {isMobile} from 'react-device-detect';

import DescriptionField from './Occupation/DescriptionField';
import EmployedSinceField from './Occupation/EmployedSinceField';
import EmployerField from './Occupation/EmployerField';
import PhoneField from './Occupation/PhoneField';
import StatusField from './Occupation/StatusField';

class OccupationFields extends Component {
  render() {
    let occupationFields;
    if(this.props.status === "Employed" || this.props.status === "SelfEmployed") {
      occupationFields = (
        <div>
          <DescriptionField handleChange={this.props.handleChange} validateField={this.props.validateField} {...this.props}  />
          <EmployerField handleChange={this.props.handleChange} validateField={this.props.validateField} {...this.props}  />
          <EmployedSinceField handleChange={this.props.handleChange} {...this.props} />
          <PhoneField handleChange={this.props.handleChange} validateField={this.props.validateField} {...this.props}  />    
        </div>);
    }
    return (
      <div>
        <StatusField handleChange={this.props.handleChange} {...this.props} autoFocus={!isMobile} />     
        {occupationFields}                                       
      </div>);
  }
}
OccupationFields.defaultProps= {
  handleChange:() => {}
};

OccupationFields.propTypes = {
  handleChange: PropTypes.func,
};

export default OccupationFields;


// WEBPACK FOOTER //
// ./src/components/Fields/OccupationFields.js